import whiteHorizontalLogo from "../../pages/images/logo-white-horizontal.png";
import googleplay_badge from "../../pages/images/pages/googleplay_badge.png";
import appstore_badge from "../../pages/images/pages/appstore_badge.svg";
import { Link } from "react-router-dom";
import localeText from "../../locale";

import LanguageSelectionButton from "../LanguageSelectionButton/LanguageSelectionButton";
import "./Navbar.css";
import { useState } from "react";
import { useEffect } from "react";
import GetUserInfoService from "../../service/GetUserInfoService";
import { useRef } from "react";
import { Toast } from "primereact/toast";
import Wrapper from "../Wrapper/Wrapper";
import { useFavoritesContext } from "../../contexts/FavoritesContext/FavoritesContext";
import { useUserContext } from "../../contexts/UserContext/UserContext";
import SearchInput from "../SearchProducts/Components/SearchInput/SearchInput";
import NavLinks from "../NavLinks/NavLinks";
import NavDepartmentSearch from "../NavDepartmentSearch/NavDepartmentSearch";
import CartProvider from "../../contexts/CartContext/CartContext";
import { useLocation } from "react-router-dom";
import StoreNavDropdown from "../StoreNavDropdown/StoreNavDropdown";

const Navbar = (props) => {
  const { setRightSidebarVisible } = props;

  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const { favoritesCount } = useFavoritesContext();

  const [loadingUserInfo, setLoadingUserInfo] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [OS, setOS] = useState(false);
  const { userInfo, setUserInfo } = useUserContext();

  const [numberOfCartItems, setNumberOfCartItems] = useState(-1);

  const userInfoService = new GetUserInfoService();

  const toast = useRef(null);

  const [expression, setExpression] = useState("");
  const [category, setCategory] = useState(null);

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) setOS("android");

      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) setOS("ios");
    }
  }, []);

  useEffect(() => {
    let cancel = false;

    async function fetchUserInfo() {
      if (localStorage.getItem("__extraconomy_token")) {
        try {
          setLoadingUserInfo(true);

          const resType = await userInfoService.getUserTypeInfo(
            localStorage.getItem("__extraconomy_username")
          );
          if (cancel) return;

          if (resType.result === "Admin") {
            setIsAdmin(true);
            setLoadingUserInfo(false);
            return;
          }

          const res = await userInfoService.getUserInfo(
            localStorage.getItem("__extraconomy_token"),
            localStorage.getItem("__extraconomy_username")
          );

          if (res.messageCode !== 200001) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
              life: 6000,
            });
            setLoadingUserInfo(false);
          } else {
            setUserInfo(res.result.user);
            setLoadingUserInfo(false);
          }
        } catch (e) {
          console.log(e);
        }
      }
    }

    fetchUserInfo();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("__extraconomy_token"), localStorage.getItem("__extraconomy_username")]);

  // Show number of items in cart
  useEffect(() => {
    if (localStorage.getItem(orderKey)) {
      let order = JSON.parse(localStorage.getItem(orderKey));

      if (isFringeBenefitsPage) order = { itens: [order] };

      setNumberOfCartItems(order.itens.length);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("__extraconomy_token"), localStorage.getItem("__extraconomy_username")]);

  return (
    <div className="surface-0">
      <Wrapper classnames="grid grid-nogutter align-items-center w-full bg-primary-green sm:px-4 sm:py-3 px-3 py-3">
        <Toast ref={toast} />
        <div className="md:hidden flex h-full">
          <StoreNavDropdown categories={props.categories} onSearch={props.onSearch} />
        </div>
        <Link
          to={`${JSON.parse(localStorage.getItem("__extraconomy_ismobile__")) ? "/shop" : "/"}`}
        >
          <img
            src={whiteHorizontalLogo}
            alt="Extraconomy logo white"
            className="logo-responsive"
          ></img>
        </Link>
        {props.hasSearch && (
          <SearchInput
            expression={expression}
            category={category}
            isLoading={props.isLoading}
            onSearch={props.onSearch}
            setExpression={setExpression}
            setCategory={setCategory}
            categories={props.categories}
            handleSelectedCategory={props.handleSelectedCategory}
            selectedCategory={props.selectedCategory}
            loadingCategories={props.loadingCategories}
          />
        )}

        <NavLinks
          isAdmin={isAdmin}
          userInfo={userInfo}
          loadingUserInfo={loadingUserInfo}
          favoritesCount={favoritesCount}
          numberOfCartItems={numberOfCartItems}
          hasSearch={props.hasSearch}
        />
      </Wrapper>
      {props.hasSearch && (
        <NavDepartmentSearch categories={props.categories} onSearch={props.onSearch} />
      )}
    </div>
  );
};

export default Navbar;
